import script from "./PasiveCash.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasiveCash.vue?vue&type=script&setup=true&lang=ts"

import "./PasiveCash.vue?vue&type=style&index=0&id=20a8779a&lang=scss"

const __exports__ = script;

export default __exports__